// Lecture du format Excel "Agri-cadastre" (colonnes Dénomination courante, Immatriculation, etc.)

export function stripAccents(s) {
  return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function normHeader(s) {
  return stripAccents((s ?? "").toString()).trim().toLowerCase().replace(/\s+/g, " ");
}

function normDept(s) {
  return stripAccents((s ?? "").toString()).toLowerCase().replace(/[^a-z]/g, "");
}

// Nom de département -> code (métropole, focalisé Île-de-France + alentours)
const DEPT_CODES = {
  paris: "75", seineetmarne: "77", yvelines: "78", essonne: "91",
  hautsdeseine: "92", seinesaintdenis: "93", valdemarne: "94", valdoise: "95",
  eure: "27", eureetloir: "28", oise: "60", loiret: "45", aisne: "02",
  marne: "51", yonne: "89", aube: "10", seinemaritime: "76", somme: "80",
  calvados: "14", orne: "61", sarthe: "72", loiretcher: "41", cher: "18",
  nievre: "58", manche: "50", ardennes: "08",
};

const AGRI_KEYS = new Set([
  "immatriculation",
  "denomination courante",
  "indicateur parcelle",
  "indicateur section",
  "proprietaire du lot",
  "lieu-dit officiel",
]);

export function isAgriHeaderRow(row) {
  const norm = (row || []).map((c) => normHeader(c));
  return norm.some((h) => AGRI_KEYS.has(h));
}

// Référence cadastrale (95388) à partir du département + indicateur commune (388)
function buildInsee(dept, communeIndicator) {
  const deptCode = DEPT_CODES[normDept(dept)];
  const comm = (communeIndicator ?? "").toString().replace(/\D/g, "");
  if (!deptCode || !comm) return "";
  return deptCode + comm.padStart(3, "0");
}

export function parseAgriMatrix(matrix, headerRowIdx) {
  const headers = (matrix[headerRowIdx] || []).map((c) => normHeader(c));
  const idx = (name) => headers.indexOf(name);

  const cName = idx("denomination courante");
  const cImmat = idx("immatriculation");
  const cComm = idx("indicateur commune");
  const cSection = idx("indicateur section");
  const cParc = idx("indicateur parcelle");
  const cDept = idx("departement");
  const cSurfBail = idx("surface bail");
  const cSurfCult = idx("surface cultivee");
  const cOwner = idx("proprietaire du lot");
  const cConv = idx("type de convention");
  const cRisks = idx("risques");
  const cMsa = idx("msa");
  const cLieu = idx("lieu-dit officiel");

  const get = (row, i) => (i >= 0 && row[i] != null ? row[i].toString().trim() : "");

  const parcels = [];
  for (let r = headerRowIdx + 1; r < matrix.length; r++) {
    const row = matrix[r] || [];
    const name = get(row, cName);
    const section = get(row, cSection);
    const numero = get(row, cParc);
    const immat = get(row, cImmat);
    if (!name && !immat && !section && !numero) continue; // ligne vide

    const dept = get(row, cDept);
    const commInd = get(row, cComm);
    const code_insee = buildInsee(dept, commInd);
    const surfCult = parseFloat((get(row, cSurfCult) || "").replace(",", "."));
    const surfBail = parseFloat((get(row, cSurfBail) || "").replace(",", "."));
    const area = !isNaN(surfCult) ? surfCult : !isNaN(surfBail) ? surfBail : null;

    parcels.push({
      name: name || immat || "Parcelle",
      owner: get(row, cOwner),
      crop: "",
      crop_label: "",
      area,
      notes: "",
      commune: commInd,
      code_insee,
      section: section.toUpperCase(),
      numero,
      immat,
      dept,
      lieu_dit: get(row, cLieu),
      lease_type: get(row, cConv),
      risks: get(row, cRisks),
      msa: get(row, cMsa),
      source: "excel",
      polygon: null,
      needsGeometry: !!(code_insee && section && numero),
    });
  }
  return parcels;
}
